import React, { useState , useEffect } from "react";
 // Ensure this CSS isn't hiding the confirmation box
import axios from "axios";

const LaptopAcceForm = () => {
  const [formData, setFormData] = useState({
    deviceName: "",
    employeeName: "",
    regionalOffice: "",
    contactNo: "",
    personalEmail: "",
    address: "",
    dateOfIssue: "",
    serialNo: "",
    deviceTransferred: "no",
    deviceIntakeEmployeeName: "",
    deviceIntake: "no",
    reportingManager: "",
    deviceIntakeDate: "",
    exitFormalityComplete: "no",
  });

  const [isVisible, setIsVisible] = useState(true);
  const [message, setMessage] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    const storedName = sessionStorage.getItem('name');
    const storedmobile = sessionStorage.getItem('mobile');
    const storedaddress = sessionStorage.getItem('address');
    const storedareaoffice = sessionStorage.getItem('areaoffice');
    const storedareaemail = sessionStorage.getItem('email');

    setFormData((prevData) => ({
    ...prevData,
    employeeName: storedName || '',
    regionalOffice: storedareaoffice || '',
    address: storedaddress || '',
    contactNo: storedmobile || '',
    personalEmail: storedareaemail || '',
  }));
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://api.assetview.warrantyindia.com/api/accessories1", formData);
      setMessage("Employee created successfully!");
      setShowConfirmation(true);
      setFormData({  
        deviceName: "",
        employeeName: "",
        regionalOffice: "",
        contactNo: "",
        personalEmail: "",
        address: "",
        dateOfIssue: "",
        serialNo: "",
        deviceTransferred: "no",
        deviceIntakeEmployeeName: "",
        deviceIntake: "no",
        reportingManager: "",
        deviceIntakeDate: "",
        exitFormalityComplete: "no",
      });
      setTimeout(()=>{
        setIsVisible(false);
      },500)
      console.log(response.data);
    } catch (error) {
      console.error("Error submitting form", error);
      setMessage("An error occurred while creating the employee.");
      setShowConfirmation(true);
    }
  };


  return (
    <div className="modal-backdrop" style={{ display: isVisible ? 'flex' : 'none' }}>
    <div className="form-container">
      <button style={{padding:'10px' , color:'white' , background:'red' , border:'none'}} onClick={handleClose}>Close</button>
      <h2>Create New Employee</h2>
      <form onSubmit={handleSubmit}>
        {/* Basic form fields */}

        <div className="form-group">
            <label>Device Name</label>
            <input
              type="text"
              name="deviceName"
              value={formData.deviceName}
              onChange={handleInputChange}
              
            />
          </div>


        
        <div className="form-group" style={{display:"none"}}>
            <label>Employee Name</label>
            <input
              type="text"
              name="employeeName"
              value={formData.employeeName}
              onChange={handleInputChange}
              
            />
          </div>

        <div className="form-group" style={{display:"none"}}>
          <label>Regional Office</label>
          <input
            type="text"
            name="regionalOffice"
            value={formData.regionalOffice}
            onChange={handleInputChange}
            
          />
        </div>

        <div className="form-group" style={{display:"none"}}>
          <label>Contact No</label>
          <input
            type="text"
            name="contactNo"
            value={formData.contactNo}
            onChange={handleInputChange}
            
          />
        </div>

        <div className="form-group" style={{display:"none"}}>
          <label>Email</label>
          <input
            type="email"
            name="personalEmail"
            value={formData.personalEmail}
            onChange={handleInputChange}
            
          />
        </div>

        <div className="form-group" style={{display:"none"}}>
          <label>Address</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            
          />
        </div>

        <div className="form-group">
          <label>Date of Issue</label>
          <input
            type="date"
            name="dateOfIssue"
            value={formData.dateOfIssue}
            onChange={handleInputChange}
            required
          />
        </div>

        {/* <div className="form-group">
          <label>Model Name</label>
          <input
            type="text"
            name="modelName"
            value={formData.modelName}
            onChange={handleInputChange}
            required
          />
        </div> */}

        <div className="form-group" style={{display:"none"}}>
          <label>Serial No</label>
          <input
            type="text"
            name="serialNo"
            value={formData.serialNo}
            onChange={handleInputChange}
            
          />
        </div>

        {/* Device Transferred Dropdown */}
        <div className="form-group" style={{display:"none"}}>
          <label>Device Transferred</label>
          <select
            name="deviceTransferred"
            value={formData.deviceTransferred}
            onChange={handleInputChange}
          >
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>

        {/* Conditional Fields based on deviceTransferred being 'yes' */}
        {formData.deviceTransferred === "yes" && (
          <>
            <div className="form-group" style={{display:"none"}}>
              <label>Device Intake Employee Name</label>
              <input
                type="text"
                name="deviceIntakeEmployeeName"
                value={formData.deviceIntakeEmployeeName}
                onChange={handleInputChange}
                required={formData.deviceTransferred === "yes"}
              />
            </div>

            <div className="form-group" style={{display:"none"}}>
              <label>Device Intake</label>
              <select
                name="deviceIntake"
                value={formData.deviceIntake}
                onChange={handleInputChange}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            {/* Conditional Fields based on deviceIntake being 'yes' */}
            {formData.deviceIntake === "yes" && (
              <>
                <div className="form-group" style={{display:"none"}}>
                  <label>Device Intake Date</label>
                  <input
                    type="date"
                    name="deviceIntakeDate"
                    value={formData.deviceIntakeDate}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group" style={{display:"none"}}>
                  <label>Reporting Manager</label>
                  <input
                    type="text"
                    name="reportingManager"
                    value={formData.reportingManager}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group" style={{display:"none"}}>
                  <label>Exit Formality Complete</label>
                  <select
                    name="exitFormalityComplete"
                    value={formData.exitFormalityComplete}
                    onChange={handleInputChange}
                  >
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
              </>
            )}
          </>
        )}

        <button type="Submit" className="submit-btn">
          Submit
        </button>
        
      </form>
      {showConfirmation && (
        <div className="confirmation-modal">
          <p>{message}</p>
          <button
            onClick={() => setShowConfirmation(false)}
            className="close-confirmation-btn"
          >
            Close
          </button>
        </div>
      )}
      
    </div>
    </div>
  );
};

export default LaptopAcceForm;
